import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const MostUsedRuleContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MostUsedRuleProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["most_used_rule"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=most-used-rules`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <MostUsedRuleContext.Provider value={contextValue}>
      {children}
    </MostUsedRuleContext.Provider>
  );
};

export default MostUsedRuleProvider;
